export const GOOGLE_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY || "AIzaSyDmLGXQybgt6GH35ZNMYQvX9Vf9ZhIEy_8";
export const TEST_ENV_PAYMENT_URL =
    process.env.REACT_APP_PAYMENT_URL || "https://3dsgate-dev.borica.bg/cgi-bin/cgi_link";
export const IS_PAYMENT_ENABLED = process.env.REACT_APP_IS_PAYMENT_ENABLED === "true";
